import { render, staticRenderFns } from "./FemaleRank.vue?vue&type=template&id=54465daa&scoped=true&"
import script from "./FemaleRank.vue?vue&type=script&lang=js&"
export * from "./FemaleRank.vue?vue&type=script&lang=js&"
import style0 from "./FemaleRank.vue?vue&type=style&index=0&id=54465daa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54465daa",
  null
  
)

export default component.exports